var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2498 2.83328H11.9248C11.5659 1.18537 10.0313 0.00199223 8.24989 0H6.74975C4.96836 0.00199223 3.43341 1.18537 3.07481 2.83328H0.749895C0.335747 2.83328 0 3.15037 0 3.54151C0 3.93265 0.335747 4.24975 0.749895 4.24975H1.49979V13.4582C1.50225 15.4132 3.17993 16.9977 5.24996 17H9.75003C11.8201 16.9977 13.4977 15.4132 13.5002 13.4582V4.24975H14.2501C14.6643 4.24975 15 3.93265 15 3.54151C15 3.15037 14.6643 2.83328 14.2501 2.83328H14.2498ZM6.74975 12.0417C6.74975 12.4328 6.41401 12.7499 5.99986 12.7499C5.58571 12.7499 5.24996 12.4328 5.24996 12.0417V7.7916C5.24996 7.40046 5.58571 7.08336 5.99986 7.08336C6.41401 7.08336 6.74975 7.40046 6.74975 7.7916V12.0417ZM9.74968 12.0417C9.74968 12.4328 9.41394 12.7499 8.99979 12.7499C8.58564 12.7499 8.24989 12.4328 8.24989 12.0417V7.7916C8.24989 7.40046 8.58564 7.08336 8.99979 7.08336C9.41394 7.08336 9.74968 7.40046 9.74968 7.7916V12.0417ZM4.62804 2.83328C4.94691 1.98492 5.79665 1.4178 6.74975 1.41647H8.24989C9.203 1.41747 10.0527 1.98492 10.3716 2.83328H4.62804Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminar);
export default __webpack_public_path__ + "static/media/eliminar.b7d0e7bb96dcebebb6db47404ef95427.svg";
export { ForwardRef as ReactComponent };